export const STATUS = {
  not_started: { label: "Not started", cls: "bg-[#F4EFE6] text-[#8C827A]" },
  shortlisted: { label: "Shortlisted", cls: "bg-[#EFE6F3] text-[#3B1B48]" },
  skip: { label: "Skip", cls: "bg-[#F4EFE6] text-[#8C827A] line-through" },
  queued: { label: "Queued", cls: "bg-[#FEF3C7] text-[#B45309]" },
  building: { label: "Building", cls: "bg-[#FEF3C7] text-[#B45309]" },
  built: { label: "Built", cls: "bg-[#C59B27]/15 text-[#7A5E12]" },
  published: { label: "Published", cls: "bg-[#2D6A4F]/10 text-[#2D6A4F]" },
  failed: { label: "Failed", cls: "bg-[#B42318]/10 text-[#B42318]" },
};
